var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.119
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.088 18.636.706-.796a57.993 57.993 0 0 0 2.163-2.616l.53-.699c2.21-2.978 3.316-5.342 3.316-7.089 0-3.729-3.006-6.751-6.715-6.751S1.373 3.707 1.373 7.436c0 1.747 1.106 4.111 3.316 7.09l.53.698a61.357 61.357 0 0 0 2.869 3.412Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.088 10.197a2.798 2.798 0 1 0 0-5.595 2.798 2.798 0 0 0 0 5.595Z"
  }))));
};
export default SvgLocation;